import { render, staticRenderFns } from "./listRewardHorizontal.vue?vue&type=template&id=6311f1f0&scoped=true"
import script from "./listRewardHorizontal.vue?vue&type=script&lang=js"
export * from "./listRewardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./listRewardHorizontal.vue?vue&type=style&index=0&id=6311f1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311f1f0",
  null
  
)

export default component.exports